import { Component, OnInit, ViewChild, AfterViewInit, ViewEncapsulation, Input, Renderer2, ChangeDetectorRef } from '@angular/core';
import { CompositeFilterDescriptor, filterBy, process, State } from '@progress/kendo-data-query';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { GItem } from '@app/cp/shared/models/GItem';
import { CustomerService } from '@app/cp/shared/services/customer.service';
import { DropDownListComponent, DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { Subscription } from 'rxjs';
import { ColumnMenuSettings, PageChangeEvent, SelectableSettings, SelectionEvent } from '@progress/kendo-angular-grid';
import { DQOIComponent } from '@app/cp/dqoi/dqoi.component';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { WindowContents } from '@app/cp/shared/enums/windowContents';
import { DispatchData } from '@app/cp/shared/models/DispatchData';
import { MSCLFilterClass } from '@app/cp/shared/classes/filters/MSCLFilterClass';
import { aggregateBy } from '@progress/kendo-data-query';
import { DispatchSearchType } from '@app/cp/shared/enums/dispatchSearchType';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { GridComponent } from "@progress/kendo-angular-grid";
import { element } from "protractor";
import * as _ from 'lodash';
import { ActivatedRoute, Params } from '@angular/router';
import { CommonParam } from '../../shared/models/CommonParam';
import { BaseMessageInfo } from '../../shared/models/BaseMessageInfo';
import { DQOIService } from '../../shared/services/DQOI.service';
import { v_InventoryXferHistoryBus } from '../../shared/models/v_InventoryXferHistoryBus';
import { BaseGridEditFormLinesComponent } from '../../shared/base-components/base-grid-edit-formlines.component';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SaveMode } from '../../shared/enums/SaveMode';
import { BaseGridEditLineComponent } from '../../shared/base-components/base-grid-editline.component';
import { InventoryService } from '../../shared/services/inventory.service';
import { GenericSearchComponent } from '../../shared/search/generic-search/generic-search.component';
import { v_InventoryCostHistoryBus } from '../../shared/models/v_InventoryCostHistoryBus';
import { InvoiceMessageInfo } from '../../shared/models/InvoiceMessageInfo';
import { CommonValues } from '../../shared/static/CommonValues';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { DateFunctions } from '../../shared/static/date-functions';
import { InventoryCostAdjustments } from '../../shared/models/InventoryCostAdjustmentsBus';
import { v_InventoryPriceByMonthDetailBus } from '../../shared/models/v_InventoryPriceByMonthDetailBus';
import { ConfirmOutput } from '../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../shared/enums/CPDialogResult';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'parts-cost-history',
    templateUrl: './parts-cost-history.component.html',
    styleUrls: ['./parts-cost-history.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PartsCostHistoryComponent extends BaseGridEditLineComponent<v_InventoryCostHistoryBus, null, InventoryService>  {
    //dispatchStatusNameCF: MSCLFilterClass;
    //locationNameCF: MSCLFilterClass;
    //priorityNameCF: MSCLFilterClass;

    constructor(svc_data: InventoryService, globals: GlobalsService, private svc_cust: CustomerService, private qry_rd: DQOIReferenceDataQuery, private sanitizer: DomSanitizer, private activatedRoute: ActivatedRoute, renderer: Renderer2, cd: ChangeDetectorRef, private svc_dqoi: DQOIService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.className = "v_InventoryCostHistoryBus";
        this.appCode = "InventoryCostHistoryBus";
        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();
        this.advSearchParam = new CommonParam();
        this.saveMode = SaveMode.individual;

    }
    endDate: any;
    testMode: boolean = false;
    public menuSettings: ColumnMenuSettings = {
        lock: true,
        //stick: true,
        //setColumnPosition: { expanded: true },
        //autoSizeColumn: true,
        //autoSizeAllColumns: true,
    };
    subs_dataRef: Subscription;
    // Dynamic parameters for this component's route: /example-params/:first/:second
    @ViewChild('genSearch') protected genSearch: GenericSearchComponent;

    ngAfterViewInit() {
        if (this.genSearch) {
            this.genSearch.clear();
        }
       // this.recalculateLoader = true;
        this.doAdvSearch(null);
    }
    override ngOnDestroy() {
        super.ngOnDestroy();
        CommonFunctions.unsubscribe(this.subs_dataRef);
    }
    detailOpened: boolean = false;

    detailActive: boolean = false;
    subs_detail: Subscription;
    detailData: v_InventoryPriceByMonthDetailBus[];
    cancelDetail() {
        this.detailActive = false;
    }
    showDetail(dataItem: v_InventoryCostHistoryBus) {
        let param: CommonParam = new CommonParam();
        param.addParam("inventoryId", dataItem.inventoryId);
        param.addParam("period", dataItem.period);
        CommonFunctions.unsubscribe(this.subs_detail);
        this.subs_detail = this.svc_data.getInventoryCostDetail(param).subscribe((info: BaseMessageInfo) => {
            let arr = [];
            if (CommonFunctions.hasArrayValue(info.primaryReturn)) {
                for (let i = 0; i < info.primaryReturn.length; i++) {
                    let newObj: v_InventoryCostHistoryBus = new v_InventoryCostHistoryBus(info.primaryReturn[i]);
                    arr.push(newObj);
                }
            }
            this.detailData = arr;
            this.detailActive = true;
            console.log("partscosthistory: ", info, this.detailData);
        });
    }

    advSearchParam: CommonParam = new CommonParam();
    doAdvSearch(param: CommonParam) {
        if (this.hasGridData) {
            this.clear();
        }
        this.advSearchParam.addParam("SearchCode", "CP_PartsCostHistory");
        //if (this.advSearchParam.dcParams.hasParams) {
        //    this.advSearchParam.addParam("SearchCode", "CP_PartsCostHistory");
        //}

        this.dataLoading = true;
        this.svc_dqoi.generic_Search(this.advSearchParam).subscribe((info: BaseMessageInfo) => {

            let gridDataOriginal = info.primaryReturn; //JSON.parse(info.primaryReturn);
            this.ListData = gridDataOriginal;
            this.dataLoading = false;
            this.recalculateLoader = false;
        });
    }
    advSearchCancel(e: any) {

    }
    exceptionPctSetting() {
        this.svc_data.getInventoryCostExceptionPct().subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                let numberValue = CommonFunctions.getNumberValue(info.primaryReturn);
                console.log("exceptionPctSetting->agd: ",numberValue, info, info.primaryReturn);
                this.cnfShowCustomValue(numberValue, 1, "Exception %");
            }
        });
        //this.cnfShowCustomValue()
    }
    confirmCustom(data: ConfirmOutput) {
        if (data.dialogResult == CPDialogResult.ok) {
            console.log("confirmCustom: ", data);
            this.svc_data.saveInventoryCostExceptionPct(data.data).subscribe((info: BaseMessageInfo) => {
            })
        }
    }
    filterClear() {
        this.selectedData = null;
        this.gridData = null;
    }
    rowSelected(e: SelectionEvent) {
        this.selectedData = e.selectedRows[0].dataItem;
    }
    recalculateLoader: boolean = false;
    reCalculate() {
        this.clear();
        let param: CommonParam = new CommonParam();
        param.endDate = this.endDate; // DateFunctions.getDateNow();
        param.addParam("Periods", 24);
        param.addParam("ClearExisting", true);
        param.addParam("TestMode", this.testMode);
        this.recalculateLoader = true;
        this.svc_data.inventoryCostCalculate(param).subscribe((info: BaseMessageInfo) => {

            this.recalculateLoader = false;
            this.doAdvSearch(null);
        });

    }
    toggleExceptionAck(dataItem: v_InventoryCostHistoryBus) {
        this.selectedData = dataItem;
        let dataObj: InventoryCostAdjustments = new InventoryCostAdjustments(null);
        dataObj.inventoryCostAdjustmentId = dataItem.inventoryCostAdjustmentId;
        dataObj.acknowledgedInventoryId = dataItem.inventoryId;
        dataObj.acknowledgedYear = dataItem.year;
        dataObj.acknowledgedMonth = dataItem.month;
        if (!CommonFunctions.hasGuidValue(dataObj.inventoryCostAdjustmentId)) {
            dataObj.setCommon(this.globals.userId, DateFunctions.getDateNow());
            dataObj.setBeforeSave();
        }
        this.svc_data.inventoryCostHistoryException_Acknowledge(dataObj).subscribe((info: BaseMessageInfo) => {
            console.log("toggleExceptionAck: ", info);
            if (CommonFunctions.hasGuidValue(this.selectedData.inventoryCostAdjustmentId)) {
                this.notify("Acknowledgement Removed");
            }
            else {
                this.notify("Acknowledgement Aded");
            }
            this.doAdvSearch(null);
            //this.notify("Looks Good: " + dataItem.inventoryCostHistoryId);
            // this.selectedData.
        });
    }
    public ackColorCode(dataItem: v_InventoryCostHistoryBus, code: string): SafeStyle {
        let color: string;
        if (code == "flag") {
            if (dataItem.pctDiffFlag) {
                color = "#eb2a47"
            }
        }
        else if (code == "exc") {
            if (dataItem.pctDiffException) {
                color = "#eb2a47"
            }
            else if (dataItem.isAcknowledged) {
                color = "#2aeb8a"
            }
        }
        else if (code == "ack") {
            if (dataItem.isAcknowledged) {
                color = "#2aeb8a"
            }
        }
        return this.sanitizer.bypassSecurityTrustStyle(color);
    }
}
